export default {
  '_b._qhyy': 'Schimbă limba',

  '_a._jzz': 'Se încarcă...',
  '_a._jzgd': 'Încarcă mai mult',
  '_a._wct': 'Bun venit la',
  '_a._gd': 'Mai mult',
  '_a._bf': 'Redă',
  '_a._bcz': 'Se salvează...',
  '_a._sctp': 'Încarcă imagine',

  '_dl._qssyx': 'Te rugăm să introduci adresa de email',
  '_dl._qssmm': 'Te rugăm să introduci parola',
  '_dl._ann': 'Autentificare',
  '_dl._hmyzh': 'Nu ai un cont?',
  '_dl._qzc': 'Înregistrare',
  '_dl._yzhl': 'Ai deja un cont?',
  '_dl._qdl': 'Autentificare',
  '_dl._srqrmm': 'Te rugăm să confirmi parola',
  '_dl._sryqm': 'Te rugăm să introduci codul de invitație',
  '_dl._sryzm': 'Te rugăm să introduci codul de verificare',
  '_dl._ljzc': 'Înregistrează-te acum',
  '_dl._zcbsty': 'Înregistrarea înseamnă că ai citit și ești de acord cu',
  '_dl._yszc': 'Politica de Confidențialitate',
  '_dl._lcmmbyy': 'Parolele nu coincid',

  '_yzm._fsyzm': 'Trimite cod de verificare',
  '_yzm._cxfs': '({time}) Retrimite',
  '_yzm._fsz': 'Se trimite...',
  '_yzm._fscg': 'Trimis cu succes',

  '_h._zrm': 'Cel mai popular',
  '_h._zxd': 'Cel mai recent',
  '_h._phb': 'Clasament',
  '_h._qz': 'Fundaluri',
  '_h._ssww': 'Căutare',
  '_h._lsjl': 'Istoric',
  '_h._gd': 'Mai mult',
  '_h._dl': 'Autentificare',
  '_h._ye': 'Sold',
  '_h._dj': 'Înghețat',
  '_h._ybp': 'Panou de control',
  '_h._wdqb': 'Portofelul meu',
  '_h._scjl': 'Favorite',
  '_h._xxzx': 'Centru de mesaje',
  '_h._fxhy': 'Distribuie prietenilor',
  '_h._bzzx': 'Centru de ajutor',
  '_h._ggtf': 'Plasare publicitate',
  '_h._bqtz': 'Investiție drepturi de autor',
  '_h._sz': 'Setări',

  '_sy._jx': 'Recomandate',
  '_sy._xpfb': 'Lansări noi',
  '_sy._gdsp': 'Mai multe videoclipuri',

  '_qz._jbqz': 'Colecție fundaluri rafinate',
  '_qz._ssqz': 'Caută fundal',
  '_qz._qb': 'Toate',
  '_qz._zrfg': 'Peisaje naturale',
  '_qz._cxys': 'Artă abstractă',
  '_qz._csjz': 'Arhitectură urbană',
  '_qz._dmyx': 'Anime și jocuri',
  '_qz._yzxk': 'Cosmos și stele',
  '_qz._yl': 'Previzualizare',
  '_qz._xzqz': 'Descarcă fundal',
  '_qz._fbl': 'Rezoluție',
  '_qz._fl': 'Categorie',
  '_qz._jzz': 'Se încarcă',
  '_qz._myzdpp': 'Nu s-au găsit fundaluri potrivite',

  '_sp._xyjscl': 'Necesită deblocare pentru vizionare',
  '_sp._cz': 'Reîncarcare',
  '_sp._jsqj': 'Deblochează toate episoadele',
  '_sp._jsbj': 'Deblochează acest episod',
  '_sp._sc': 'Favorite',
  '_sp._fx': 'Distribuie',
  '_sp._jsqjjs': 'Confirmi plata {a} pentru deblocarea tuturor episoadelor?',
  '_sp._jsbjjs': 'Confirmi plata {a} pentru deblocarea acestui episod?',
  '_sp._zfz': 'Se procesează plata...',
  '_sp._qrzf': 'Confirmă plata',
  '_sp._qx': 'Anulează',

  '_qz._smrc': 'Răsărit montan',
  '_qz._cxjh': 'Geometrie abstractă',
  '_qz._dsyj': 'Peisaj urban nocturn',
  '_qz._dmfj': 'Peisaj anime',
  '_qz._hhxk': 'Cer înstelat vast',
  '_qz._slmw': 'Ceață de pădure',
  '_qz._scld': 'Flux de culoare',
  '_qz._xdjz': 'Arhitectură modernă',

  '_qb._cbjl': 'Istoric depuneri',
  '_qb._jyjl': 'Istoric tranzacții',
  '_qb._bddz': 'Adrese asociate',
  '_qb._txjl': 'Istoric retrageri',

  '_m._tcdl': 'Deconectare',
  '_m._cb': 'Depune',
  '_m._tb': 'Retrage',

  '_cb._ssdz': 'Caută monedă sau adresă',
  '_cb._bz': 'Monedă',
  '_cb._je': 'Sumă',
  '_cb._dz': 'Adresă',
  '_cb._sj': 'Timp',
  '_cb._cz': 'Acțiune',
  '_cb._zwjl': 'Nicio tranzacție încă',
  '_cb._dny': 'Pagina {a} din {b}',
  '_cb._jyxq': 'Detalii tranzacție',
  '_cb._jydz': 'Adresa tranzacției',
  '_cb._zt': 'Stare',
  '_cb._yqr': 'Confirmat',
  '_cb._qb': 'Toate',
  '_cb._jt': 'Astăzi',
  '_cb._j7t': 'Ultimele 7 zile',
  '_cb._j30t': 'Ultimele 30 zile',
  '_cb._zw': 'Niciunul',
  '_cb._fzcg': 'Adresă copiată în clipboard',

  '_jyjl._ssdz': 'Caută monedă sau adresă',
  '_jyjl._lx': 'Tip',
  '_jyjl._je': 'Sumă',
  '_jyjl._ye': 'Sold',
  '_jyjl._dj': 'Înghețat',
  '_jyjl._sj': 'Timp',
  '_jyjl._cz': 'Acțiune',
  '_jyjl._zwjyjl': 'Nicio tranzacție încă',
  '_jyjl._czsx': 'Resetează filtru',
  '_jyjl._dny': 'Pagina {a} din {b}',
  '_jyjl._jyxq': 'Detalii tranzacție',
  '_jyjl._jylx': 'Tip tranzacție',
  '_jyjl._jyje': 'Suma tranzacției',
  '_jyjl._jyhye': 'Sold după tranzacție',
  '_jyjl._djye': 'Sumă înghețată',
  '_jyjl._jysj': 'Ora tranzacției',
  '_jyjl._jyzt': 'Starea tranzacției',
  '_jyjl._ywc': 'Finalizat',
  '_jyjl._qb': 'Toate',
  '_jyjl._jt': 'Astăzi',
  '_jyjl._j7t': 'Ultimele 7 zile',
  '_jyjl._j30t': 'Ultimele 30 zile',

  '_jyjl._tp1': 'Depunere',
  '_jyjl._tp2': 'Retragere',
  '_jyjl._tp3': 'Plată',
  '_jyjl._tp4': 'Depunere',
  '_jyjl._tp5': 'Îngheață',
  '_jyjl._tp6': 'Câștiguri',
  '_jyjl._tp7': 'Recompensă invitație',
  '_jyjl._tp8': 'Recompensă autentificare',
  '_jyjl._tp9': 'Câștiguri promoție',
  '_jyjl._tp10': 'Recompensă videoclip',
  '_jyjl._tp11': 'Bonus înregistrare',
  '_jyjl._tp12': 'Retragere respinsă',
  '_jyjl._tp13': 'Pachet mesaj roșu',

  '_jyjl._tp14': 'Transfer intern',

  '_cb._shz': 'În revizuire',
  '_cb._yyg': 'Aprobat',
  '_cb._ybh': 'Respins',

  '_bddz._tjdz': 'Adaugă adresă',
  '_bddz._ssdz': 'Caută adresă',
  '_bddz._bz': 'Monedă',
  '_bddz._dz': 'Adresă',
  '_bddz._sysj': 'Ultima utilizare',
  '_bddz._cz': 'Acțiune',
  '_bddz._zwjl': 'Nicio adresă încă',
  '_bddz._dny': 'Pagina {a} din {b}',
  '_bddz._dzewm': 'Cod QR adresă',
  '_bddz._fzdz': 'Copiază adresă',
  '_bddz._dzxq': 'Detalii adresă',
  '_bddz._wl': 'Rețea',
  '_bddz._tjsj': 'Data adăugării',
  '_bddz._bzwa': 'Notă',
  '_bddz._ntq': 'Acum {a} zile',
  '_bddz._nxsq': 'Acum {a} ore',
  '_bddz._nfzq': 'Acum {a} minute',
  '_bddz._ngg': 'Chiar acum',
  '_bddz._dzyfz': 'Adresă copiată în clipboard',
  '_bddz._scqr': 'Confirmare ștergere',
  '_bddz._scqrdz': 'Sigur vrei să ștergi această adresă?',
  '_bddz._qr': 'Confirmă',
  '_bddz._qx': 'Anulează',
  '_bddz._scdzcg': 'Adresă ștearsă cu succes',

  '_txjl._ztsx': 'Filtru stare',
  '_txjl._qbzt': 'Toate stările',
  '_txjl._shz': 'În revizuire',
  '_txjl._ytg': 'Aprobat',
  '_txjl._yjj': 'Respins',
  '_txjl._ssdz': 'Caută adresă sau sumă',
  '_txjl._bz': 'Monedă',
  '_txjl._je': 'Sumă',
  '_txjl._dz': 'Adresă',
  '_txjl._zt': 'Stare',
  '_txjl._sj': 'Timp',
  '_txjl._cz': 'Acțiune',
  '_txjl._zwjl': 'Nicio tranzacție încă',
  '_txjl._czsx': 'Resetează filtru',
  '_txjl._dny': 'Pagina {a} din {b}',
  '_txjl._jyxq': 'Detalii tranzacție',
  '_txjl._skdz': 'Adresă de primire',
  '_txjl._jysj': 'Ora tranzacției',
  '_txjl._jyzt': 'Starea tranzacției',
  '_txjl._fzdz': 'Adresă copiată în clipboard',

  '_cbsq._bz': 'Monedă',
  '_cbsq._wl': 'Rețea',
  '_cbsq._erwm': 'Cod QR',
  '_cbsq._fzdz': 'Copiază adresă',

  '_txsq._bz': 'Monedă',
  '_txsq._wl': 'Rețea',
  '_txsq._ye': 'Sold',
  '_txsq._sxf': 'Comision',
  '_txsq._zxtx': 'Retragere minimă',
  '_txsq._txdz': 'Adresă retragere',
  '_txsq._qxztxdz': 'Te rugăm să selectezi adresa de retragere',
  '_txsq._txje': 'Suma de retras',
  '_txsq._qsrtxje': 'Te rugăm să introduci suma de retras',
  '_txsq._yxyzm': 'Cod verificare email',
  '_txsq._qsryxyzm': 'Te rugăm să introduci codul de verificare',
  '_txsq._ljtx': 'Retrage acum',

  '_jl._wxhd': 'Preferatele mele',
  '_jl._lsjl': 'Istoric',

  '_xx._bt': 'Centru de mesaje',
  '_xx._wjl': 'Nicio înregistrare',
  '_xx._zsmyxx': 'Niciun mesaj încă',
  '_xx._sxxx': 'Reîmprospătează mesaje',
  '_xx._sxcg': 'Reîmprospătat cu succes',

  '_fx._fxhy': 'Distribuie prietenilor',
  '_fx._smfx': 'Scanează cod QR pentru a distribui prietenilor',
  '_fx._jlsm': 'Descriere recompensă',
  '_fx._jlsm1': '1. Prietenii pe care îi inviți direct (Nivel 1) îți oferă {a}% din câștigurile lor.',
  '_fx._jlsm2': '2. Prietenii invitați de prietenii tăi de Nivel 1 (Nivel 2) îți oferă {a}% din câștigurile lor.',
  '_fx._jlsm3': '3. Prietenii invitați de prietenii tăi de Nivel 2 (Nivel 3) îți oferă {a}% din câștigurile lor.',
  '_fx._fzlj': 'Copiază link',

  '_bzzx._bzzx': 'Centru de ajutor',
  '_bzzx._rhzczh': 'Cum să creezi cont',
  '_bzzx._zclc': 'Proces înregistrare',
  '_bzzx._rhzcxyh': 'Cum să înregistrezi cont nou?',
  '_bzzx._rhzcxyh1': 'Apasă "Înregistrare", introdu email, setează parola și completează verificarea email.',

  '_bzzx._rhcz': 'Cum să reîncarci?',
  '_bzzx._rhcz1': 'Proces reîncărcare',
  '_bzzx._rhcz2': 'Instrucțiuni detaliate reîncărcare',
  '_bzzx._rhcz3': 'Apasă Portofelul Meu, Depune, selectează criptomoneda și trimite la adresa furnizată.',

  '_bzzx._rhjsdj': 'Cum să deblochezi dramă scurtă',
  '_bzzx._rhjsdj2': 'Apasă pentru a debloca episoade individuale.',

  '_bzzx._rhtx': 'Cum să retragi din cont',
  '_bzzx._rhtx1': '1. Mergi la Portofelul Meu, Adrese de retragere, adaugă adresă nouă.<br>2. Apasă Retrage, selectează moneda, introdu suma și așteaptă.',

  '_bzzx._qtwt': 'Alte întrebări',
  '_bzzx._qtwt1': 'Cum să contactezi suportul?',
  '_bzzx._qtwt2': 'Contactează-ne prin chat online, email sau telefon.',
  '_bzzx._myzdwt': 'Nu ai găsit răspunsul?',
  '_bzzx._khjybbzn': 'Echipa noastră te va ajuta cu plăcere.',
  '_bzzx._lxkf': 'Contactează suport',

  '_ggtf._bt1': 'Plasare publicitate',
  '_ggtf._splb': 'Listă videoclipuri',
  '_ggtf._wcyd': 'Participarea mea',
  '_ggtf._hdbm': 'Cod eveniment',
  '_ggtf._tian': 'Zile',
  '_ggtf._kssj': 'Ora start',
  '_ggtf._jssj': 'Ora sfârșit',
  '_ggtf._ddvp': 'Atinge nivel VIP {a}, medie {b} participări pe persoană',
  '_ggtf._hdzt': 'Starea evenimentului',
  '_ggtf._wks': 'Nu a început',
  '_ggtf._ycy': 'Participat',
  '_ggtf._qg': 'Cumpără acum',
  '_ggtf._mygdl': 'Nu mai sunt date',
  '_ggtf._qgrtd': 'Prea mulți cumpărători, încearcă din nou',
  '_ggtf._hdxq': 'Detalii eveniment',
  '_ggtf._hdjs': 'Descriere eveniment',
  '_ggtf._cyyq': 'Cerințe participare',
  '_ggtf._zdtz': 'Investiție minimă',
  '_ggtf._vpdj': 'Nivel VIP',
  '_ggtf._rjcy': 'Participare medie',
  '_ggtf._gmje': 'Suma cumpărării',
  '_ggtf._qsrgmje': 'Te rugăm să introduci suma cumpărării',
  '_ggtf._qx': 'Anulează',
  '_ggtf._ljcy': 'Participă acum',
  '_ggtf._ssjymm': 'Introdu parola de tranzacție',
  '_ggtf._qssjymm': 'Te rugăm să introduci parola de tranzacție',
  '_ggtf._ji': 'Nivel',
  '_ggtf._ci': 'ori',
  '_ggtf._zdgm': 'Suma minimă de cumpărare',
  '_ggtf._zggm': 'Suma maximă de cumpărare',
  '_ggtf._zfz': 'Se procesează plata...',

  '_wdtg._wjl': 'Nicio participare încă',
  '_wdtg._tzje': 'Suma investită',
  '_wdtg._zsy': 'Câștiguri totale',
  '_wdtg._hdts': 'Durata evenimentului',
  '_wdtg._cysj': 'Ora participării',
  '_wdtg._qzf': 'Mergi la plată',
  '_wdtg._jxz': 'În desfășurare',
  '_wdtg._djszje': 'Suma totală în așteptare',
  '_wdtg._gjb': 'Total {a} elemente',
  '_wdtg._djs': 'În așteptare',
  '_wdtg._zrsy': 'Câștigurile de ieri',
  '_wdtg._dbl': 'Redări la cerere',
  '_wdtg._bfl': 'Număr de redări',
  '_wdtg._wdsy': 'Câștigurile mele',
  '_wdtg._bqffc': 'Cotă deținător drepturi',
  '_wdtg._mr0djs': 'Câștigurile de ieri decontate zilnic la 00:00',
  '_wdtg._jrsy': 'Câștigurile de azi',
  '_wdtg._mygd': 'Nu mai sunt date',

  '_bqyy._bqyy': 'Programare colaborare drepturi autor',
  '_bqyy._qrbq': 'Confirmi programarea colaborării?',
  '_bqyy._qx': 'Anulează',
  '_bqyy._tjyy': 'Trimite programare',

  '_bqyy._spsq': 'Solicitare colaborare videoclip',
  '_bqyy._spsy': 'Promovează videoclipuri împreună pentru mai mult trafic și câștiguri!',
  '_bqyy._ljyy': 'Programează acum',
  '_bqyy._sphz': 'Ce este colaborarea pentru drepturi de autor?',
  '_bqyy._sphzsm': 'Colaborarea oferă mai multă expunere pentru beneficiu reciproc.',
  '_bqyy._sqhch': 'Beneficii colaborare',
  '_bqyy._llfz': 'Suport trafic',
  '_bqyy._llfzsm': 'Crește-ți expunerea și redările.',
  '_bqyy._sytg': 'Câștiguri sporite',
  '_bqyy._sytgsm': 'Beneficiezi de venituri publicitare mai mari.',
  '_bqyy._yxhz': 'Colaborare prioritară',
  '_bqyy._yxhzsm': 'Participă prioritar la evenimente oficiale.',
  '_bqyy._yytj': 'Condiții programare',
  '_bqyy._sptg': 'Cerințe promovare videoclip',
  '_bqyy._sptgsm': 'Participă la cel puțin 1 promoție videoclip.',
  '_bqyy._yysm': 'Echipa noastră te va contacta în 3 zile lucrătoare.',

  '_ybp._wdsy': 'Câștigurile mele',
  '_ybp._dqye': 'Sold curent',
  '_ybp._jr': 'Astăzi',
  '_ybp._jrzsy': 'Câștiguri totale astăzi',
  '_ybp._ljzsy': 'Câștiguri totale cumulative',
  '_ybp._tgfh': 'Dividende promoție',
  '_ybp._ljsy': 'Câștiguri cumulative',
  '_ybp._bqsy': 'Câștiguri drepturi autor',
  '_ybp._yqfh': 'Dividende invitație',
  '_ybp._mrsy': 'Câștiguri zilnice',
  '_ybp._tgsy': 'Câștiguri promoție',

  '_tjdz._tjxd': 'Adaugă adresă nouă',
  '_tjdz._xzbz': 'Selectează monedă',
  '_tjdz._qbdz': 'Adresa portofelului',
  '_tjdz._srdz': 'Te rugăm să introduci adresa portofelului',
  '_tjdz._qx': 'Anulează',
  '_tjdz._bc': 'Salvează',

  '_sz._smrz': 'Verificare identitate',
  '_sz._rzlx': 'Tip verificare',
  '_sz._sfzzm': 'Fața actului de identitate',
  '_sz._sfzfm': 'Verso act identitate',
  '_sz._zsxm': 'Nume real',
  '_sz._qsrzsxm': 'Te rugăm să introduci numele real',
  '_sz._sfzhm': 'Număr act identitate',
  '_sz._qsrsfzhm': 'Te rugăm să introduci numărul actului',
  '_sz._yyzz': 'Licență comercială',
  '_sz._qymc': 'Nume companie',
  '_sz._yyzzh': 'Număr licență comercială',
  '_sz._qsrqymc': 'Te rugăm să introduci numele companiei',
  '_sz._qsryyzzh': 'Te rugăm să introduci numărul licenței',
  '_sz._qx': 'Anulează',
  '_sz._tjrz': 'Trimite verificare',
  '_sz._zt': 'Stare',
  '_sz._gr': 'Individual',
  '_sz._qy': 'Companie',
  '_sz._shz': 'În revizuire',
  '_sz._ytg': 'Aprobat',
  '_sz._ybh': 'Respins',

  '_mm._xgmm': 'Schimbă parola',
  '_mm._dqxg': 'Schimbă parola regulat pentru securitate',
  '_mm._dqmm': 'Parola curentă',
  '_mm._xmm': 'Parola nouă',
  '_mm._qrxmm': 'Confirmă parola nouă',
  '_mm._qx': 'Anulează',
  '_mm._qrxg': 'Confirmă schimbarea',

  '_jymm._xgjymm': 'Schimbă parola de tranzacție',

  '_szzx._sz': 'Setări',
  '_szzx._yrz': 'Verificat',
  '_szzx._wrz': 'Neverificat',
  '_szzx._jymm': 'Parola de tranzacție',
  '_szzx._szjymm': 'Setează sau schimbă parola de tranzacție',
  '_szzx._tcdl': 'Deconectare',
  '_szzx._qdtcdl': 'Sigur vrei să te deconectezi?',
  '_szzx._qrtc': 'Confirmă deconectarea',
  '_szzx._qx': 'Anulează',

  '_yj._gy': 'Despre',

  '_yj._lxwm': 'Contactați-ne',

  '_yj._yszc': 'Politica de confidențialitate',

  '_yj._yhxy': 'Acord de utilizare',

  '_cd._gszz': 'Calificări ale companiei',

  '_cd._wmyy': 'Deținem calificări și certificări complete în domeniu, oferind utilizatorilor servicii video legale, sigure și de înaltă calitate',

  '_cd._yyzz': 'Dovadă validă a funcționării legale a companiei, care demonstrează informațiile noastre oficiale de înregistrare și domeniul de activitate',

  '_cd._yyzz2': 'O licență comercială certificată de companie, obținută legal, care asigură legalitatea și conformitatea platformei',

  '_bz._lxkf': 'Faceți clic mai jos pentru a contacta serviciul clienți sau contactați-ne prin e-mailul serviciului clienți sau prin linia telefonică directă',

  '_sz._bjtx': 'Editare',

  '_sz._bjxx': 'Editați mesajul',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Salvare',

  '_db._zskf': 'Contactează suportul',
  '_db._zsry': 'Agent dedicat',
  '_db._wdq': 'Necitit',
  '_db._ydq': 'Citit',

  '_sc._sctp': 'Încarcă imagine',
  '_sc._xztp': 'Alege imagine',
  '_sc._fstp': 'Trimite imagine',
  '_sc._qx': 'Anulează',
  '_sc._hd': 'Bine',

  '_zcyl._zcbt': 'Bonus de înregistrare',
  '_zcyl._djdkhb': 'Atinge pentru a deschide plicul roșu',
  '_zcyl._zclj': 'Recompensă de înregistrare',
  '_zcyl._hmyzh': 'Nu ai cont?',
  '_zcyl._qzc': 'Înregistrează-te',
  '_zcyl._qxdjhb': 'Te rog revendică-ți mai întâi recompensa',
  '_zcyl._qwzc': 'Mergi la înregistrare',
  '_zcyl._hbysy': 'Recompensa a fost deja folosită',

  '_ggtg._qhz': 'Mergi la Transfer',
  '_ggtg._dqye': 'Sold Curent',
  '_ggtg._qcz': 'Mergi la Depunere',
  '_ggtg._hzje': 'Suma Transferului',
  '_ggtg._ljhz': 'Transferă Imediat',
  '_ggtg._yebz': 'Sold Insuficient',

  '_sq._bhbt': 'Respins',

  '_sq._bhyy': 'Motivul respingerii',

  '_xx._ntq': 'Acum {n} zile',

  '_xx._nxsq': 'Acum {n} ore',

  '_xx._nfzq': 'Acum {n} minute',

  '_xx._nggq': 'Chiar acum',

  '_xx._djckgd': 'Faceți clic pentru a vedea mai multe',

  '_ct._zt': 'Stare',

  '_ct._ljz': 'Conectare',

  '_ct._ylj': 'Conectat',

  '_ct._ltlieb': 'Listă de chat',

  '_ct._bnhzj': 'Nu pot discuta cu mine însumi',

  '_ct._cylb': 'Listă de membri',

  '_hb._fhb': 'Plic roșu',

  '_hb._dqye': 'Sold curent',

  '_hb._fsd': 'Trimis către',

  '_hb._hbje': 'Suma plicului roșu',

  '_hb._qshuru': 'Vă rugăm să introduceți suma din plicul roșu',

  '_hb._ljfs': 'Trimiteți acum',

  '_hb._hbz': "Plic roșu' Binecuvântare",
  '_hb._qshuruzhu': 'Vă rugăm să introduceți binecuvântarea dumneavoastră',
  '_sp._cuow': 'Episoadele 1-10 trebuie deblocate înainte de a le putea viziona',

  '_bq._tzzq': 'Perioada de investiție',

  '_bq._zrsy': 'Profitul de ieri',

  '_bq._bqtz': 'Investiție în drepturi de autor',

  '_bq._tzdj': 'Suma investiției',

  '_bq._zfjz': 'Plata trebuie efectuată în termen de 24 de ore, altfel va fi considerată o renunțare!',

  '_bq._qzf': 'Efectuați plata',

  '_bq.jz': 'Termen limită',

  '_bq._ljzf': 'Plătiți acum',

  '_bq._sqbz': 'Note de aplicare (opționale)',

  '_bq._sqbzsm': 'Vă rugăm să introduceți notele de aplicare',

  '_bq._zzsqz': 'Cerere de drepturi de autor în curs, în așteptarea revizuirii...',

  '_app._xz': 'Descărcați aplicația ReelShortBiz',

  '_app._smerm': 'Scanați codul QR pentru a descărca',

  '_app._xzbt': 'Descărcare',

  '_m._yhzz': 'Transfer bancar',
  '_m._yhxx': 'Informații bancare',
  '_m._yhmz': 'Numele băncii',
  '_m._yhdz': 'Adresa băncii',
  '_m._yhmc': 'Nume',
  '_m._yhzh': 'Cont',
  '_m._yhlx': 'Tip',
  '_m._yhly': 'Rutare',
  '_m._yhdm': 'Cod',
  '_m._yhbz': 'Notă',
  '_m._fzxx': 'Copiază informațiile',

  '_m._zts': 'Sfaturi',

  '_m._zyd1': '1. Vă rugăm să verificați cu atenție numele destinatarului, numărul de cont și codul bancar atunci când transferați fonduri. Orice eroare poate duce la pierderea remitenței.',

  '_m._zyd2': '2. Se recomandă selectarea opțiunii „Remitentul suportă toate comisioanele” pentru a evita fondurile insuficiente din cauza deducerilor bancare intermediare.',

  '_m._zyd3': '3. Transferurile durează de obicei 1-3 zile lucrătoare. Vă rugăm să aveți răbdare. Dacă aveți întrebări, vă rugăm să contactați serviciul clienți.',

  '_m._zyd4': '4. Dacă aveți alte întrebări, vă rugăm să contactați serviciul clienți.',

  '_m._jyh': 'Numărul tranzacției',

  '_m._jyje': 'Sumă',

  '_sp._dbye': 'Sold VOD',
  '_sp.hzye': 'Transfer',
  '_sp._txje': 'Suma transferată',
  '_sp._qsrtxje': 'Introduceți suma de transfer',
  '_sp._ljhz': 'Transferați acum',
  '_sp._yebz': 'Sold insuficient',
  '_sp._qshuru': 'Introduceți suma corectă de transfer',
  '_sp._fanh': 'Înapoi',

  '_sp._tliu': 'Plasare Anunțuri',
  '_sp._xzgj': 'Selectează Țara',
  '_sp._cdcw': 'Eroare de Codificare Video',
  '_ggtf._hot': 'Popular',
  '_tl._tlsj': 'Timp Publicitate',
  '_tl._xzxb': 'Selectează Sexul',
  '_tl._nan': 'Bărbat',
  '_tl._nv': 'Femeie',
  '_tl._hunhe': 'Mixt',
  '_tl._xznl': 'Selectează Vârsta',
  '_sp._us': 'Statele Unite',
  '_sp._en': 'Regatul Unit',
  '_sp._jp': 'Japonia',
  '_sp._fr': 'Franța',
  '_sp._kr': 'Coreea de Sud',
  '_sp._de': 'Germania',
  '_sp._id': 'India',
  '_sp._in': 'Indonezia',
  '_sp._au': 'Australia',
  '_sp._es': 'Spania',
  '_sp._my': 'Malaezia',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Înapoi',
  '_ggtf._jymmts': 'Confirmați suma tranzacției și introduceți parola',
  '_wdtg._wjl_desc': 'Nu ați participat încă la nicio campanie publicitară',
  '_wd._jxz': 'În desfășurare',
  '_wd._djs': 'În așteptarea decontării',
  '_wd._ywc': 'Finalizat',
  '_wd._jz': 'Urgent',
  '_wd._hz': 'Transfer',

  '_tl._tlfbqk': 'Distribuția cheltuielilor publicitare',
  '_tl._tlfbqk_desc': 'Zilele 1-5: 5% (Faza de pornire la rece), Zilele 6-10: 20% (Faza de validare a conținutului), Zilele 11-15: 40% (Faza de construire IP), Zilele 16-20: 35% (Faza de matrice de seriale scurte)',

  '_nhz._sm': 'După transfer, suma va fi transferată în portofelul video pentru deblocarea conținutului video',
  '_nhz._zhzz': 'Se transferă...',
  '_nhz._zzcg': 'Transfer reușit',
  '_nhz._zhzsb': 'Transfer eșuat, încercați din nou',
  '_m._fzcg': 'Copiat cu succes',
  '_m._fzsb': 'Copiere eșuată, copiați manual',
  '_m._zwfzxx': 'Nicio informație de copiat',
  '_tx._qb': 'Toate',
  'activity.detail': 'Detalii Activitate',
  'activity.noDesc': 'Nicio descriere a activității',
  'activity.desc': 'Descriere Activitate',
  'activity.requirements': 'Cerințe de Participare',
  'activity.minInvest': 'Investiție Minimă',
  'activity.vipLevel': 'Nivel VIP',
  'activity.avgParticipation': 'Participare Medie',
  'activity.avgParticipationDesc': 'ori',
  'activity.country': 'Selectați Țara',
  'activity.deliveryTime': 'Timp de Publicitate',
  'activity.deliveryTimeDesc': 'zile',
  'activity.gender': 'Selectați Genul',
  'activity.male': 'Masculin',
  'activity.female': 'Feminin',
  'activity.mixed': 'Mixt',
  'activity.age': 'Selectați Vârsta',
  'activity.amount': 'Suma de Cumpărare',
  'activity.back': 'Înapoi',
  'activity.join': 'Participă Acum',
  emptyData: 'Nicio Dată',
  emptyDataDesc: 'Nicio campanie publicitară participantă',
  completedtlement: 'Expirat',
  preheat: 'Preîncălzire',
  progress: 'În Desfășurare',
  settlement: 'În Așteptarea Decontării',
  transfered: 'Transferat',
  completed: 'Finalizat',
  activityCode: 'Cod Activitate',
  touzAmount: 'Suma Investiției',
  activityDays: 'Zile de Activitate',
  joinTime: 'Ora Participării',
  playSource: 'Distribuția Sursei de Redare',
  allPlatforms: 'Toate Platformele',
  other: 'Altele',
  totalPlayNum: 'Total Redări',
  incomeSummary: 'Rezumat Venituri',
  totalPay: 'Taxe de Drepturi de Autor Plătite',
  totalIncome: 'Venit Total',
  copyrightRatio: 'Cota Deținătorului de Drepturi',
  promotionIncome: 'Venit din Promovare',
  copyrightIncome: 'Cota de Drepturi de Autor',
  playNum: 'Redări',
  buyNum: 'Redări la Cerere',
  incomeRate: 'Rata de Distribuție',
  yjIncome: 'Venit Estimat',
  paid: 'Plătit',
  timeout: 'Expirat',
  transfer: 'Transferă Acum',
  loading: 'Se Încarcă...',
  loadMore: 'Încarcă Mai Mult',
  noMore: 'Nu Mai Sunt',
  nightTime: 'Perioada Nopții',
  morningTime: 'Perioada Dimineții',
  afternoonTime: 'Perioada După-amiezii',
  eveningTime: 'Perioada Serii',
  '_h._tc': 'Deconectare',
  periodPayment: 'Plată pe Perioadă',
  periodPaymentDesc: 'Decontarea are loc de 4 ori pe zi în 4 perioade, puteți plăti taxele de drepturi de autor pe perioadă',

  day: 'zi',
  '_dl._hy': 'Bun venit înapoi',
  '_dl._cj': 'Creează cont',
  '_dl._zmm': 'Resetează parola',
  '_dl._hyDesc': 'Conectează-te la contul tău pentru a continua să explorezi conținut excelent',
  '_dl._cjDesc': 'Alătură-te ReelShortBiz și începe călătoria ta captivantă',
  '_dl._zmmDesc': 'Introdu emailul și îți vom trimite un cod de verificare pentru resetare',
  '_dl._hlgqsp': 'Resurse extinse de filme și videoclipuri HD',
  '_dl._gxhty': 'Algoritmi de recomandare personalizați',
  '_dl._ffddsp': 'Videoclipuri scurte variate',
  '_dl._dlzh': 'Autentificare',
  '_dl._sdndyx': 'Introdu emailul și parola pentru a continua',
  '_dl._email': 'Adresă de email',
  '_dl._qsryx': 'Te rugăm să introduci adresa de email',
  '_dl._dlmm': 'Parolă',
  '_dl._qsrmm': 'Te rugăm să introduci parola',
  '_dl._wjmm': 'Ai uitat parola?',
  '_dl._immdl': 'Autentifică-te acum',
  '_dl._hmyzh2': 'Nu ai un cont?',
  '_dl._ljzc2': 'Înregistrează-te acum',
  '_dl._cjzh': 'Creează cont',
  '_dl._jswmd': 'Alătură-te ReelShortBiz și începe călătoria ta captivantă',
  '_zh._qszmm': 'Te rugăm să îți setezi parola',
  '_zh._qrmm': 'Confirmă parola',
  '_zh._qmm': 'Te rugăm să introduci parola din nou',
  '_zc._yqm': 'Cod de invitație',
  '_zc._sryqm': 'Te rugăm să introduci codul de invitație',
  '_dl._yzm': 'Cod de verificare',
  '_dl._qsryzm': 'Te rugăm să introduci codul de verificare',
  '_dl._yjyzh': 'Ai deja un cont?',
  '_dl._zcbsty2': 'Prin înregistrare ești de acord cu',
  '_dl._zcbstyDesc': 'Politica de confidențialitate',
  '_dl._newmm': 'Parolă nouă',
  '_dl._qszxmm': 'Te rugăm să setezi o parolă nouă',
  '_dl._qrmm': 'Confirmă parola',
  '_dl._qzcsrmm': 'Te rugăm să introduci noua parolă din nou',
  '_dl._czmm': 'Resetează parola',
  '_dl._xqlmm': 'Ți-ai amintit parola?',
  '_dl._fhdl': 'Înapoi la autentificare',
  '_dl._srdllmmbyz': 'Parolele nu se potrivesc',
  '_dl._czcg': 'Parola resetată cu succes',
  '_h._zc': 'Înregistrare',
  // '_ybp._wdsy': 'Câștigurile mele',
  '_ybp._jrsy': 'Câștigurile de astăzi',
  '_ybp._jztr': 'Comparativ cu ieri',
  '_ybp._bfl': 'Vizualizări',
  '_ybp._dbl': 'Cereri',
  '_ybp._syqs': 'Tendința câștigurilor',
  // '_ybp._jr': 'Astăzi',
  '_ybp._t': 'zi',
  // '_ybp._dqye': 'Sold cont',
  '_ybp._djs': 'În așteptarea decontării',
  '_ybp._zhl': 'Rată de conversie',
  '_ybp._sjgl': 'Prezentare generală date',
  '_ybp._zrsy': 'Câștigurile de ieri',
  '_ybp._bysy': 'Câștigurile acestei luni',
  '_ybp._yysj': 'Date operaționale',
  '_ybp._zr': 'Ieri',
  '_ybp._zjfrs': 'Total utilizatori plătitori',
  '_ybp._mtdqje': 'Suma de încasat mâine',
  '_ybp._jsy': 'Câștig net',
  '_ybp._bqfy': 'Plan de plată pentru drepturi de autor',
  '_ybp._yzf': 'Plătit',
  '_ybp._qzf': 'Mergi la plată',
  '_ybp._bqfyts': 'După plata drepturilor de autor, câștigurile și drepturile tale vor fi prioritizate',
  '_ybp._syjl': 'Istoric câștiguri',
  '_ybp._ckgd': 'Vezi mai mult',
  '_ybp._ssdt': 'Actualizări live',
  '_ybp._bzzx': 'Centru de ajutor',
  '_ybp._lxkf': 'Contactează asistența',
  '_ybp._zrxz': 'Câștigurile de ieri',
  '_ybp._zdsy': 'Câștiguri totale',
  '_ybp._qygy': 'Luna trecută',
  '_ybp._jsjl': 'Istoric decontări',
  '_ybp._hzjl': 'Istoric transferuri',
  '_ybp._jfzq': 'minute în urmă',
  '_ybp._fzq': 'ore în urmă',
  '_ybp._djs_mt': 'Suma de decontare mâine',
  '_yj._rule': 'Reguli ale platformei',

  '_bq._jjks': 'Începe acum',
  '_bq._jxz': 'În desfășurare',
  '_bq._jks': 'Timp până la început',
  '_bq._jjs': 'Timp până la sfârșit',
  '_bq._t': 'z',
  '_bq._h': 'h',
  '_bq._m': 'm',
  '_bq._s': 's',
  '_bq._kssj': 'Ora începerii',
  '_bq._jssj': 'Ora sfârșitului',
  '_bqq._tzdj': 'Preț unitar',
  '_bqq._hdts': 'Zile de eveniment',
  '_bqq._vip': 'Nivel VIP',
  '_bqq._rjcy': 'Participare medie',
  '_bqq._cs': 'ori',
  '_bqq._ysjd': 'Progres vânzări',
  '_bqq._ljqg': 'Cumpără acum',
  '_bqq._zbkqg': 'Indisponibil momentan',
  '_bqq._jzz': 'Se încarcă',
  '_bqq._jzgd': 'Încarcă mai multe',
  '_bqq._wz': 'Nu mai sunt',

  '_sp._gdsj': 'Total {n} episoade',
  '_sy._jl': 'Înregistrare decontare în așteptare',
  '_ybp._zsy': 'Venit total',
  '_ybp._djsjl': 'Înregistrare decontare în așteptare',
  '_ybp._bqbm': 'Cod',
  '_ybp._je': 'Sumă',
  '_ybp._sj': 'Timp',
  '_sy._djs': 'În așteptare',
  '_sy._yjs': 'Decontat',
  '_sy._gdstjl': 'Total {n} înregistrări',
  '_sy._gjd': 'Total {n}',

  '_sp.tgdy':'Suma nu poate fi mai mică decât {a}',
  '_sp.tggy':'Suma nu poate fi mai mare decât {a}',

  '_tg._zdyje': 'Sumă personalizată'
}
